import { useAuth } from '../context/AuthContext';

/**
 * Hook to check if a feature is enabled for the current tenant's plan.
 *
 * @param {string} featureKey - The feature key to check (e.g. "payroll", "crm")
 * @returns {{ enabled: boolean, planTier: string }}
 */
const usePlanFeature = (featureKey) => {
  const { featureFlags, planTier, isSuperAdmin } = useAuth();

  // Super admins always have access to everything
  if (isSuperAdmin && isSuperAdmin()) {
    return { enabled: true, planTier: planTier || 'ALL' };
  }

  if (!featureKey) {
    return { enabled: true, planTier: planTier || 'FREE' };
  }

  const enabled = Array.isArray(featureFlags) &&
    (featureFlags.includes(featureKey) || featureFlags.includes('ALL'));

  return { enabled, planTier: planTier || 'FREE' };
};

export default usePlanFeature;
